import { useEffect, useState } from "react";
import styles from "../../../styles/news.module.css";
import images from "../../../images";
import { Link, useLocation } from "react-router-dom";
import loadingImg from "../../../images/igs_logo.png";
import { useSearchParams } from "react-router-dom";
import { requesturl } from '../../../shared/utils/requesturl';

const BLOGS_API = `${requesturl}blogs.php`;
const Blogs = ({limit,searchquery}) => {
  const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [seachparams]=useSearchParams();
    const searchqueryparams=seachparams.get("search");
  useEffect(() => {
    setLoading(true);
    let url = BLOGS_API;
        let params=[];
    if(searchquery)params.push(`search=${encodeURIComponent(searchquery)}`);
        if(limit)params.push(`limit=${limit}`);
    if(params.length>0){
      url+="?"+params.join("&");
    }


    
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) =>{

            setBlogs(data);
            setLoading(false);
        })
      .catch((err) => {
            console.error(err);
            setLoading(false);
        });
        console.log("Fetched blogs from "+url);
        console.log(params)
            }, [searchqueryparams]);

  // Register service worker and request notification permission


  if(loading){
    return <div className={styles.loadingContainer}>
        <img className={styles.loading} src={images["igs_logo"]} alt="Loading..." />
    </div>;
  }else{
  return (
    <div className={styles.newsContainer}>
      <div className={styles.newsWrapper}>
        <h1
          className={styles.newsHeader}
        >
          News and Updates
        </h1>
        {
          blogs.length>0?(
        blogs.map((blog, idx) => (
          <div className={styles.newsItem} key={idx}>
            <img
              src={images["igs_logo"]}
              alt={blog.title}
              className={styles.newsImage}
            />
            <p className={styles.newsdate}>{blog.date}</p>
            <p className={blog.author}>Admin</p>
            <img
              src={images["library"]}
              alt={blog.title}
              className={styles.newsCoverImage}
            />

            <h2>
              {blog.title}
            </h2>
            <p>{blog.content}</p>

            <Link to={`/blogs/${blog.title}`}>
              <li className={styles.largebtn}>Read more</li>
            </Link>
          </div>
        ))
      ):<div className={styles.noresults}>No news found</div>
      }
      
      </div>
    </div>
  );
}
};

export default Blogs;
